export default __webpack_public_path__ + "static/media/13-IHeart-Black.d1571ff3.png";